import { render, staticRenderFns } from "./myTest.vue?vue&type=template&id=5875cc33&scoped=true"
import script from "./myTest.vue?vue&type=script&lang=js"
export * from "./myTest.vue?vue&type=script&lang=js"
import style0 from "./myTest.vue?vue&type=style&index=0&id=5875cc33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5875cc33",
  null
  
)

export default component.exports